import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tag-state"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M23 4L1 4L1 20L23 20L23 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M23 4L1 4L1 20L23 20L23 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 12L6 9C6 8.44771 6.44772 8 7 8L9 8C9.55228 8 10 8.44771 10 9V12M6 12L6 16M6 12H10M10 12V16M14 12V8H17C17.5523 8 18 8.44772 18 9V12M14 12H18M14 12V16H17C17.5523 16 18 15.5523 18 15V12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TagState = Vue.extend<IconProps>({
  name: 'TagStateIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tag-state',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TagState;
